<template>
  <div>
    <my-table :title="title"
              :isAdd="isAdd"
              :tableData="tableData"
              :isSearch="isSearch"
              @pageNumChange="pageNumChange"
              @add="add">
      <div slot="table">
        <Terms-table :tableData="tableData.list" @update="update"></Terms-table>
      </div>
    </my-table>
  </div>
</template>

<script>
  import TermsTable from "./TermsTable";
  import MyTable from "../../components/content/myTable/MyTable";
  import {getTermsList,newVue} from "../../network/terms";

  export default {
    name: "TermsList",
    components: {TermsTable, MyTable},
    data(){
      return {
        title: "条款信息列表",
        isAdd:true,
        tableData:{},
        isSearch: false,
        searchItems:{}
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo = {
        href: "/terms/list",
        name: "条款信息管理"
      };

      this.common.HeaderLocationTwo.href = "/terms/list";
      this.common.HeaderLocationTwo.name = "条款信息管理";
      this.common.HeaderLocationThree.name = "条款信息列表"
      getTermsList().then(res => {
        this.tableData = res.data
      })
    },
    methods:{
      add(){
        this.$router.push("insert/");
      },
      pageNumChange(pageNum){
        this.searchEasy(this.searchItems,pageNum);
      },
      search(searchItems){
        this.searchItems = searchItems;
        this.searchEasy(searchItems)
      },
      searchEasy(searchItems,pageNum){
        // let labelName = null;
        // for (let i = 0;i<searchItems.length;i++){
        //   if (searchItems[i].value === "labelName") {
        //     labelName = searchItems[i].input
        //   }
        // }
        getTermsList(pageNum).then(res => {
          this.tableData = res.data
        })
      },
      update(id){
        this.$router.push("insert/"+id)
      }
    }
  }
</script>

<style scoped>

</style>
